import React, { memo } from "react";
import { makeStyles, Popper } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  popper: {
    minWidth: "fit-content",
  },
}));

const CustomPopper = ({ ...props }) => {
  const classes = useStyles();
  return (
    <Popper
      {...props}
      style={{
        popper: classes.popper,
      }}
    />
  );
};

export default memo(CustomPopper);
